export const SET_THEME = 'SET_THEME';
export const SET_BREADCRUMB = 'SET_BREADCRUMB';
export const SET_VIEW_CHATBOT = 'SET_VIEW_CHATBOT';